import type { FunctionComponent } from 'react';
import { useState } from 'react';

import { useTranslate } from '~/shared/context/use-translate';

type VersionNoteLineProps = {
    readonly note: string;
    readonly onExpandedChange?: (expanded: boolean) => void;
};

export const VersionNoteLine: FunctionComponent<VersionNoteLineProps> = ({ note, onExpandedChange }) => {
    const translate = useTranslate();
    const [expanded, setExpanded] = useState(false);

    const expandedTitle = translate('pages.job-architecture-v2.version-note.collapse');
    const ariaLabel = translate('pages.job-architecture-v2.version-note.aria-label', { note });

    const baseClass =
        'm-0 cursor-pointer border-0 bg-transparent p-0 text-left font-sans text-body-xs font-normal text-gray-800 transition-[color,opacity] duration-200 ease hover:text-black-900 hover:opacity-80 focus:outline-none focus-visible:underline';
    const stateClass = expanded ? 'whitespace-normal [overflow-wrap:anywhere]' : 'block w-full truncate';

    return (
        <button
            aria-expanded={expanded}
            aria-label={ariaLabel}
            className={`${baseClass} ${stateClass}`}
            title={expanded ? expandedTitle : note}
            type="button"
            onClick={(event) => {
                event.stopPropagation();
                setExpanded((value) => {
                    const nextValue = !value;
                    onExpandedChange?.(nextValue);
                    return nextValue;
                });
            }}
        >
            “{note}”
        </button>
    );
};
